import { ClassificationParameter, ClassificationType } from "../../../interfaces/classification";
import { FieldTypes } from "../../../interfaces/service";

export const ATTRIBUTE_TYPES_MAP: Partial<Record<FieldTypes, ClassificationType>> = {
  Int32: ClassificationType.Range,
  Int64: ClassificationType.Range,
  Double: ClassificationType.Range,
  DateTime: ClassificationType.Range,
  String: ClassificationType.Unique,
};

export enum ParameterType {
  Color = "color",
  Number = "number",
  Symbol = "symbol",
}

export const PARAMETER_TYPES_MAP: Record<ClassificationParameter, ParameterType> = {
  fillColor: ParameterType.Color,
  ["fill.color"]: ParameterType.Color,
  ["fill.hatchColor"]: ParameterType.Color,
  strokeColor: ParameterType.Color,
  ["stroke.color"]: ParameterType.Color,
  strokeWidth: ParameterType.Number,
  ["stroke.width"]: ParameterType.Number,
  fontColor: ParameterType.Color,
  haloColor: ParameterType.Color,
  ["textBackground.fill.color"]: ParameterType.Color,
  ["figure.fillColor"]: ParameterType.Color,
  ["figure.strokeColor"]: ParameterType.Color,
  ["figure.strokeWidth"]: ParameterType.Number,
  ["background.fillColor"]: ParameterType.Color,
  ["background.strokeColor"]: ParameterType.Color,
  ["background.strokeWidth"]: ParameterType.Number,
  size: ParameterType.Number,
  symbol: ParameterType.Symbol,
  maskedColor: ParameterType.Color,
  angle: ParameterType.Number,
  beginningSize: ParameterType.Number,
  endingSize: ParameterType.Number,
  maxObjectCount: ParameterType.Number,
  gridSize: ParameterType.Number,
  selectionObjectsLimit: ParameterType.Number,
  offset: ParameterType.Number,
};

const SIZE_PARAMETERS = ["size", "height", "strokeWidth", "stroke.width"];

export const isSizeClassification = (parameter: string): boolean => SIZE_PARAMETERS.includes(parameter);

export const getClassificationType = (type: FieldTypes | ""): ClassificationType =>
  ATTRIBUTE_TYPES_MAP[type] || ClassificationType.Range;
